module.exports = __webpack_public_path__ + "img/jinggaio.c0ee8cb4.png";